import React, { useRef, useEffect, useState } from "react";
import { Container, Button } from "react-bootstrap";
import "../styles/TestimonialsSection.scss";
import Logo from "../assets/logo.png";
import review1 from "../assets/1.png";
import review2 from "../assets/2.png";
import review3 from "../assets/3.png";
import review4 from "../assets/4.png";
import review5 from "../assets/5.png";
import review6 from "../assets/6.png";
import review7 from "../assets/7.png";
import review8 from "../assets/8.png";
import review9 from "../assets/9.png";
import review10 from "../assets/10.png";
import review11 from "../assets/11.png";

function ImageCarousel({
  images = [
    review1,
    review2,
    review3,
    review4,
    review5,
    review6,
    review7,
    review8,
    review9,
    review10,
    review11,
  ],
  interval = 5000, // ms between auto‑slides
}) {
  const carouselRef = useRef();
  const [animate, setAnimate] = useState(false);
  const [current, setCurrent] = useState(0);

  // 1) trigger animation on scroll into view
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
          obs.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (carouselRef.current) obs.observe(carouselRef.current);
    return () => obs.disconnect();
  }, []);

  // 2) auto‑slide
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images.length, interval]);

  const prev = () => setCurrent((c) => (c - 1 + images.length) % images.length);
  const next = () => setCurrent((c) => (c + 1) % images.length);

  return (
    <div className="image-carousel image-carousel-2" ref={carouselRef}>
      <div
        className="track"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {images.map((src, i) => (
          <div
            key={i}
            className={`slide ${animate ? "visible" : ""}`}
            style={{ "--i": i }}
          >
            <img src={src} alt={`slide-${i}`} />
          </div>
        ))}
      </div>
      <button className="nav prev" onClick={prev}>
        &larr;
      </button>
      <button className="nav next" onClick={next}>
        &rarr;
      </button>
    </div>
  );
}

export default function Services() {
  return (
    <section className="testimonials-section py-5">
      <Container>
        <div className="section-header text-center mb-4">
          <img src={Logo} alt="ThermalHydro" />
          <h2>Nossos Serviços</h2>
        </div>
        <ImageCarousel />
      </Container>
    </section>
  );
}
